<template>


                <el-select filterable clearable  v-model="data"  :placeholder="$t('请选择')" @change="handleChange">
                          <el-option :label="item.name" :value="item.value"  v-for="(item,index) in batchList" :key="index"></el-option>
                </el-select>
         
</template>
<script>

import { findList } from "@/services/batch"
export default {
    name:"batchSelect",
    data(){
        return{ data:"", batchList:[] }
    },
    props:["value"],
    watch:{
        value:{
            immediate: true,
            handler(value) {
                if (!value) {
                    this.data="";
                    this.$emit("input",value)
                } else{
                     this.data=value;
                }
            }
        }
    },
    methods:{
        handleChange(value){
            // console.log(value,"7859657")
            this.$emit("input",value)
            this.data=value;
      },

       async batchListsd(){
         const response = await findList({ page: 1, size: 999 },{});
        //  console.log(response,"748596")
         if(response&&response.code==0){
           this.batchList=response.data.list.map(item=>{
             return {name:item.batch,value:item.batch}
           })
         }
     },
    },
    mounted(){
        this.batchListsd()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/batchSelect/index.vue